// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/object-get-own-property-symbols.js